import {  SlotGameType1_3 } from "../SlotGameType1_3";
export class LuckyFire53 extends SlotGameType1_3{}